import { ChangeDetectorRef } from '@angular/core';
import { ConfigService } from '@core/shared/config';
import { DynamicDialogService } from '@common/ui/frontend-shared/dynamic-dialog';
import { CmsModulePositionComponent } from '@common/cms/frontend-shared';
import { Store } from '@ngxs/store';
import { TrackingService } from './tracking.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiInputGroupComponent } from '@common/ui/frontend-shared/input-group';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "@core/shared/config";
import * as i3 from "./tracking.service";
import * as i4 from "@common/ui/frontend-shared/dynamic-dialog";
import * as i5 from "@angular/common";
const _c0 = a0 => ({
  "overlay": a0
});
function TrackingConsentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3, 0)(3, "div", 4);
    i0.ɵɵtext(4, " Wir ben\u00F6tigen Ihre Zustimmung, anonyme Statistiken zu speichern. Hiermit m\u00F6chten wir unser Angebot f\u00FCr Sie weiter verbessern. ");
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "a", 5);
    i0.ɵɵlistener("click", function TrackingConsentComponent_Conditional_0_Template_a_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showDetails());
    });
    i0.ɵɵtext(7, "Mehr erfahren");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 6)(9, "ui-input-group", 7)(10, "button", 8);
    i0.ɵɵlistener("click", function TrackingConsentComponent_Conditional_0_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.saveConsentPreference(true));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 9);
    i0.ɵɵlistener("click", function TrackingConsentComponent_Conditional_0_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.saveConsentPreference(false));
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("position-" + ctx_r1.position);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r1.position === "overlay"));
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("rounded", true);
  }
}
// TODO: currently tracking will only work if this component is in app, as it controls TrackingService
export let TrackingConsentComponent = /*#__PURE__*/(() => {
  class TrackingConsentComponent {
    constructor(store, config, service, dialogService, cd) {
      this.store = store;
      this.config = config;
      this.service = service;
      this.dialogService = dialogService;
      this.cd = cd;
      this.dismissed = true;
      this.position = 'modal';
    }
    ngOnInit() {
      this.service.consentState.subscribe(consent => {
        this.dismissed = consent !== null;
        this.cd.markForCheck();
        // if(!this.dismissed) this.display();
      });
    }
    saveConsentPreference(consent) {
      this.service.saveConsentPreference(consent);
    }
    showDetails() {
      this.dialogService.open(CmsModulePositionComponent, {
        header: "Informationen zur Cookienutzung",
        data: {
          position: 'cookie-consent-info'
        }
      });
    }
    static {
      this.ɵfac = function TrackingConsentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackingConsentComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ConfigService), i0.ɵɵdirectiveInject(i3.TrackingService), i0.ɵɵdirectiveInject(i4.DynamicDialogService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: TrackingConsentComponent,
        selectors: [["tracking-consent"]],
        inputs: {
          position: "position"
        },
        features: [i0.ɵɵProvidersFeature([DynamicDialogService])],
        decls: 1,
        vars: 1,
        consts: [["dialog", ""], [1, "wrapper", 3, "ngClass", "class"], [1, "wrapper", 3, "ngClass"], [1, "dialog"], [1, "content"], ["e2e-more-infos-on-cookies", "", "fragment", "tracking", 3, "click"], [1, "buttons"], [3, "rounded"], ["e2e-agree-cookie-hint", "", "uiButton", "", "label", "Zustimmen", 1, "small", "agree", 3, "click"], ["uiButton", "", "label", "Ablehnen", 1, "small", "disagree", 3, "click"]],
        template: function TrackingConsentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, TrackingConsentComponent_Conditional_0_Template, 12, 6, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.dismissed ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i5.NgClass, UiButtonComponent, UiInputGroupComponent, RouterModule],
        styles: [".wrapper[_ngcontent-%COMP%]{position:fixed;z-index:1000}.dialog[_ngcontent-%COMP%]{background:var(--contentColor);color:var(--contentTextColor);padding:8px 12px 12px;border-radius:4px}.dialog[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 0 10px}.wrapper.position-top[_ngcontent-%COMP%]{top:0;left:0;right:0}.wrapper.position-modal[_ngcontent-%COMP%]{bottom:var(--trackingConsentPositionBottom, 20px);left:20px;right:20px;width:auto;pointer-events:none}.wrapper.position-modal[_ngcontent-%COMP%]   .dialog[_ngcontent-%COMP%]{box-shadow:var(--inputOverlayShadow);pointer-events:all}.wrapper.position-overlay[_ngcontent-%COMP%]{background:var(--invertedOverlaySoftColor);inset:0}.wrapper.position-overlay[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.wrapper.position-overlay[_ngcontent-%COMP%]   .dialog[_ngcontent-%COMP%]{position:static}[_nghost-%COMP%]     .ui-button.agree{--buttonBgColor:var(--primaryColor);--buttonHoverBgColor:var(--contrastColor);--buttonHoverBorderColor:var(--contrastColor)}[_nghost-%COMP%]     .ui-button.disagree{--buttonBgColor:var(--primaryDarkColor);--buttonBorderColor:var(--primaryDarkColor);--buttonHoverBgColor:var(--contrastColor);--buttonHoverBorderColor:var(--contrastColor)}@media (min-width: 768px){.dialog[_ngcontent-%COMP%]{padding:20px 20px 22px}.position-top[_ngcontent-%COMP%]   .dialog[_ngcontent-%COMP%]{display:flex}.position-top[_ngcontent-%COMP%]   .dialog[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{flex:1;padding:0 10px 0 0}.position-overlay[_ngcontent-%COMP%]   .dialog[_ngcontent-%COMP%], .position-modal[_ngcontent-%COMP%]   .dialog[_ngcontent-%COMP%]{bottom:var(--trackingConsentPositionBottom, 20px);left:initial;left:20px;width:600px;min-width:400px;max-width:40%}}"],
        changeDetection: 0
      });
    }
  }
  return TrackingConsentComponent;
})();